export default __webpack_public_path__ + "locales/it/RoomLogoCover.json?hash=db4151d0a89683d27a06d84885a70644";